import {
  FORCE_UPDATE_POSITION_HISTORY,
  FORCE_UPDATE_DEPARTMENT_HISTORY
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [FORCE_UPDATE_POSITION_HISTORY]({ dispatch }, params) {
      let url = "/kanri/force_updates/position_history";
      const res = await dispatch("apiPost", {
        url: url,
        data: { data: params.data }
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [FORCE_UPDATE_DEPARTMENT_HISTORY]({ dispatch }, params) {
      let url = "/kanri/force_updates/department_history";
      const res = await dispatch("apiPost", {
        url: url,
        data: { data: params.data }
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
